import { c as _c } from "react/compiler-runtime";
import { useMutation } from '@tanstack/react-query';
import { addAutoshipSubscription } from './addAutoshipSubscription';
import type { AddSubscriptionResponse, PostOrdergrooveAddSubscription } from './types';
type UseAddAutoshipSubscriptionParams = {
  onError?: (error: Error) => void;
  onSuccess?: (response: AddSubscriptionResponse, variables: PostOrdergrooveAddSubscription) => void;
};

/**
 * Adds an item to the customer's next Autoship order through OrderGroove.
 * Does not report to Sentry: callers log under their own key through `onError`.
 */
export function useAddAutoshipSubscription(t0) {
  const $ = _c(9);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    onError,
    onSuccess
  } = t1;
  let t2;
  if ($[2] !== onSuccess) {
    t2 = (response_0, variables) => {
      onSuccess?.(response_0, variables);
    };
    $[2] = onSuccess;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onError) {
    t3 = error => {
      onError?.(error);
    };
    $[4] = onError;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = {
      mutationFn: _temp,
      onSuccess: t2,
      onError: t3
    };
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return useMutation(t4);
}
async function _temp(data) {
  const response = await addAutoshipSubscription(data);
  if (!response) {
    throw new Error("No response from ordergroove subscription API");
  }
  return response;
}